import { getCategoryHref } from '../../utils/common/category';
import { CODE_PROMPT_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'videoPromptGeneratorType',
      analyticsName: 'image_prompt_type',
      textLabel: 'Generate prompt for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: CODE_PROMPT_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Code',
        value: getCategoryHref(CODE_PROMPT_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'codePromptGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'code_prompt_generator',
      textLabel: 'Describe what code you want to create with AI',
      placeholder:
        'E.g., "HTML code for SEO SaaS landing page" or "API call for connecting with OpenAI"',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: CODE_PROMPT_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
  {
    type: 'input',
    properties: {
      name: 'codePromptGeneratorDetails',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'code_prompt_generator_details',
      textLabel: 'Include the following details',
      placeholder: 'E.g., styles, platforms, resolutions, etc.',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      isOptional: true,
      selectedCategory: CODE_PROMPT_GENERATOR_CATEGORY,
      required: false,
      tooltipProps: null,
    },
  },
  {
    type: 'dropdown',
    properties: {
      information: null,
      name: 'length',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'length',
      textLabel: 'Choose length',
      isOptional: true,
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: 19,
      required: false,
      dropdownValues: [
        {
          title: 'Short',
          value: 'short',
        },
        {
          title: 'Medium',
          value: 'medium',
        },
        {
          title: 'Long',
          value: 'long',
        },
      ],
    },
  },
];

export default data;
